import React, { useState, useEffect } from "react";
import {
    Grid,
    Input,
    MenuItem,
    Select,
    InputLabel,
    Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Switch from "@mui/material/Switch";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from '@mui/material/styles';
import MuiGrid from '@mui/material/Grid';
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LocalAirportIcon from "@mui/icons-material/LocalAirport";
import { yellow } from '@mui/material/colors';
import Avatar from '@mui/material/Avatar';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import CommentIcon from '@mui/icons-material/Comment';
import * as dayjs from "dayjs";
import Collapse from '@mui/material/Collapse';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';
import ListSubheader from '@mui/material/ListSubheader';
import Paper from "@mui/material/Paper";
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import { Agriculture } from "@mui/icons-material";
import { trainingPrograms } from "./trainingPrograms";

const CourseDetails = ({
    setAgeGroup,
    ageGroup,
    weeks,
    setWeeks,
    extras,
    setExtras,
    selectedCenterValue,
    isFormInvalid,
    hideTitle,
    setArrivalDeparture,
    arrivalDeparture,
    is_edition_mode,
    readonly,
    is_admin,
    setTotalJourney,
    center,
    birthDate
}) => {

    const [optional_pro_activities_open, setOptionalProActivitiesOpen] = useState(true);
    const [optional_outing_open, setOptionalOpen] = useState(true);

    const handleProActivitiesClick = () => {
        setOptionalProActivitiesOpen(!optional_pro_activities_open);
    };
    const handleOutingsClick = () => {
        setOptionalOpen(!optional_outing_open);
    };

    const handleAgeGroupChange = (e) => {
        setAgeGroup(e);
        setWeeks(weeks);
    };

    const getCurrencyAsString = (currency) => {
        switch (currency) {
            case 1:
                return "€";
            case 2:
                return "£";
            case 3:
                return "$";
            default:
                return "€";
        }
    }

    const weekToRange = (week) => {
        return `${dayjs(week.startDate).format('DD/MM/YYYY')} to ${dayjs(week.endDate).format('DD/MM/YYYY')}`;
    };

    const isExtraInWeekRange = (extra) => {
        var is_in_range = false;
        for (let week of weeks) {
            if ((new Date(extra.startDate) >= new Date(week.startDate)) && (new Date(extra.startDate) <= new Date(week.endDate))) {
                is_in_range = true;
            }
        }
        return is_in_range;
    };

    const handleExtraToggle = (extra) => () => {
        const currentIndex = extras.findIndex(e => e.id === extra.id);
        const newChecked = [...extras];

        if (currentIndex === -1) {
            //Is the extra in week range ?
            for (let week of weeks) {
                if ((new Date(extra.startDate) >= new Date(week.startDate)) && (new Date(extra.startDate) < new Date(week.endDate))) {
                    if (extra.type === 0) {
                        if (!extras.some(e => e.startDate === extra.startDate)) {
                            newChecked.push(extra);
                        }
                    } else {
                        if (!extras.some(e => e.startDate === extra.startDate && e.endDate === extra.endDate)) {
                            newChecked.push(extra);
                        }
                    }
                    break;
                }
            }
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setExtras(newChecked);
    };

    const handleWeekToggle = (week) => () => {
        if (readonly) return;

        const currentIndex = weeks.findIndex(e => e.id === week.id);
        let newChecked = [...weeks];

        if (currentIndex === -1) {
            newChecked.push(week);
        } else {
            let extras_tmp = extras;
            for (let extra of extras) {
                if ((new Date(extra.startDate) >= new Date(week.startDate)) && (new Date(extra.startDate) <= new Date(week.endDate))) {
                    extras_tmp.splice(currentIndex, 1);
                    setExtras(extras_tmp);
                }
            }
            newChecked.splice(currentIndex, 1);
        }

        newChecked = newChecked.sort((a, b) => a.weekNumber - b.weekNumber);
        setArrivalDeparture(newChecked, newChecked.length > 0 ? [newChecked[0].startDate, newChecked[newChecked.length - 1].endDate] : [null, null]);
        setWeeks(newChecked);
    };


    const Grid = styled(MuiGrid)(({ theme }) => ({
        width: '100%',
        ...theme.typography.body2,
        '& [role="separator"]': {
            margin: theme.spacing(0, 2),
        },
    }));



    const extrasByName = {};

    const ageGroupsByCenter = {
        'ST': [
            { value: null, label: '' },
            { value: 1, label: 'Teens (10-12)' },
            { value: 2, label: 'Juniors (13-15)' },
            { value: 3, label: 'Seniors (16+)' },
        ],
        'QW': [
            { value: null, label: '' },
            { value: 0, label: 'Kids (6-9)' },
            { value: 1, label: 'Teens (10-12)' },
            { value: 2, label: 'Juniors (13-15)' },
            { value: 3, label: 'Seniors (16+)' },
        ],
        'VA': [
            { value: null, label: '' },
            { value: 1, label: 'Juniors (10-14)' },
            { value: 3, label: 'Seniors (15-17)' },
        ],
        'PA': [
            { value: null, label: '' },
            { value: 1, label: 'Juniors (10-14)' },
            { value: 3, label: 'Seniors (15-17)' },
        ]
    };

    function calculerAge(birthDate, refDate) {
        var age = refDate.getFullYear() - birthDate.getFullYear();
        var m = refDate.getMonth() - birthDate.getMonth();

        if (m < 0 || (m === 0 && refDate.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    function isTrainingProgramAvailable(trainingProgram) {

        const _weeks = center.weeks.filter((w) => w.weekNumber == 1);
        const finalAge = calculerAge(new Date(birthDate), new Date(_weeks[_weeks.length - 1].startDate))
        return finalAge <= trainingProgram.max && finalAge >= trainingProgram.min
    }

    const selectedCenterConfig = ageGroupsByCenter[selectedCenterValue.abbreviation] || [];

    return (
        <Paper elevation={3} display="flex" className={"step-container"}>
            {!hideTitle ?
                <Box sx={{ color: "primary.main" }}>
                    <Typography fontSize={20} fontWeight={"bold"} sx={{ marginBottom: 2 }}>
                        Course Details
                    </Typography>
                </Box> : <></>
            }

            <Grid container spacing={1}>
                <Grid item xs={12} sx={{ marginBottom: 2 }}>
                    {center.currency === 1 ?
                        <>
                            <label>Age Group :</label>
                            <Select
                                disabled={!is_admin}
                                size="small"
                                style={{ width: "100%", background: "white" }}
                                labelId="groupAge"
                                name="groupAge"
                                value={ageGroup >= 0 ? ageGroup : null}
                                error={isFormInvalid && !ageGroup}
                                onChange={(e) => handleAgeGroupChange(e.target.value)}>
                                {selectedCenterConfig.map((option) => (
                                    <MenuItem key={option.value} value={option.value} >
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </>
                        :
                        <>
                            <label>Training Program :</label>
                            <Select
                                size="small"
                                style={{ width: "100%", background: "white" }}
                                labelId="groupAge"
                                name="groupAge"
                                value={ageGroup >= 0 ? ageGroup : null}
                                error={isFormInvalid && !ageGroup}
                                onChange={(e) => {
                                    // Check if the selected program's price is 0
                                    const selectedIndex = e.target.value;
                                    const price = selectedIndex === 0 ? center.trainingProgramPrice1 :
                                                selectedIndex === 1 ? center.trainingProgramPrice2 :
                                                selectedIndex === 2 ? center.trainingProgramPrice3 :
                                                selectedIndex === 3 ? center.trainingProgramPrice4 : 0;
                                    
                                    // Check if all training program prices are 0 or null
                                    const allPricesZero = !center.trainingProgramPrice1 && !center.trainingProgramPrice2 && 
                                                        !center.trainingProgramPrice3 && !center.trainingProgramPrice4;
                                    
                                    // Use center's default price if all training program prices are 0
                                    const effectivePrice = allPricesZero ? center.pricePerWeek : price;
                                    
                                    // Only allow selection if effective price is not 0, null, or undefined
                                    if ((effectivePrice && effectivePrice > 0) || e.target.value === null) {
                                        handleAgeGroupChange(e.target.value);
                                    }
                                }}>

                                <MenuItem key={null} value={null}>
                                </MenuItem>
                                {trainingPrograms.map((option, index) => {
                                    const price = index === 0 ? center.trainingProgramPrice1 :
                                                index === 1 ? center.trainingProgramPrice2 :
                                                index === 2 ? center.trainingProgramPrice3 :
                                                index === 3 ? center.trainingProgramPrice4 : 0;
                                    
                                    // Check if all training program prices are 0 or null
                                    const allPricesZero = !center.trainingProgramPrice1 && !center.trainingProgramPrice2 && 
                                                        !center.trainingProgramPrice3 && !center.trainingProgramPrice4;
                                    
                                    // Use center's default price if all training program prices are 0
                                    const effectivePrice = allPricesZero ? center.pricePerWeek : price;
                                    const isZeroPrice = !effectivePrice || effectivePrice === 0 || effectivePrice === null;
                                    
                                    return (
                                        <MenuItem
                                            key={option.id}
                                            value={option.id}
                                            disabled={(!isTrainingProgramAvailable(option) && !is_admin) || isZeroPrice}
                                            sx={{
                                                ...(isZeroPrice && {
                                                    opacity: '0.65 !important',
                                                    color: 'rgba(0, 0, 0, 0.65) !important',
                                                    backgroundColor: 'rgba(0, 0, 0, 0.02) !important',
                                                    pointerEvents: 'none !important',
                                                    cursor: 'default !important',
                                                    '& *': {
                                                        color: 'rgba(0, 0, 0, 0.65) !important',
                                                    }
                                                })
                                            }}>
                                            <Box sx={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                width: '100%',
                                                alignItems: 'center'
                                            }}>
                                                <Typography component="span">
                                                    {option.name}
                                                </Typography>
                                                {isZeroPrice && (
                                                    <Typography 
                                                        component="span" 
                                                        sx={{ 
                                                            ml: 2, 
                                                            fontStyle: 'italic',
                                                            fontSize: '0.85em',
                                                            opacity: '0.8'
                                                        }}>
                                                        (Not Available)
                                                    </Typography>
                                                )}
                                            </Box>
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </>
                    }
                </Grid>


                {is_edition_mode ?
                    <Grid item xs={12} sx={{ marginBottom: 2 }}>
                        <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            localeText={{ start: '', end: '' }}>
                            <DateRangePicker
                                inputFormat="DD/MM/YYYY"
                                value={arrivalDeparture}
                                disabled={readonly}
                                onChange={(newValue) => {
                                    setArrivalDeparture(weeks, newValue);
                                }}
                                renderInput={(startProps, endProps) => (
                                    <React.Fragment>
                                        <Grid container spacing={1}>
                                            <Grid item xs={3}>
                                                <label htmlFor="firstname">Arrival Date</label>
                                                <br></br>
                                                <TextField size="small" {...startProps} style={{ background: "white" }} />
                                            </Grid>

                                            <Grid item xs={3} >
                                                <label htmlFor="firstname">Departure Date</label>
                                                <br></br>
                                                <TextField size="small" {...endProps} style={{ background: "white" }} />
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                )}
                            />
                        </LocalizationProvider>
                    </Grid>
                    : <></>
                }
            </Grid>

            <Grid container spacing={1} marginTop={2}>
                <Grid container spacing={1}>
                    {selectedCenterValue ? <>
                        <Grid item xs={4}>
                            <Grid container sx={{ color: "primary.main" }}>
                                <Grid item xs={1}>
                                    <ListItemIcon >
                                        <CalendarMonthIcon color="primary" />
                                    </ListItemIcon>
                                </Grid>
                                <Grid item xs={11}>
                                    <Typography fontSize={15} fontWeight={"bold"} mb={1} align={'left'}>
                                        Available Weeks :
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Paper elevation={3}>
                                <List sx={{ bgcolor: 'background.paper' }} >
                                    {selectedCenterValue.weeks
                                        .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
                                        .filter(w => new Date(w.startDate) > new Date())
                                        .map((week) => {
                                            const labelId = `checkbox-list-label-${week.id}`;
                                            return (
                                                <ListItem
                                                    key={week.id}
                                                    disablePadding>
                                                    <ListItemButton role={undefined} onClick={handleWeekToggle(week)} dense>
                                                        <ListItemIcon>
                                                            <Checkbox
                                                                edge="start"
                                                                disabled={readonly}
                                                                checked={weeks.some(e => e.id == week.id)}
                                                                tabIndex={-1}
                                                                disableRipple
                                                                inputProps={{ 'aria-labelledby': labelId }}
                                                            />
                                                        </ListItemIcon>
                                                        <ListItemText id={labelId} primary={`${weekToRange(week)}`} />
                                                    </ListItemButton>


                                                </ListItem>
                                            );
                                        })}
                                </List>
                            </Paper>

                        </Grid>
                        <Grid item xs={8}>
                            <Grid container sx={{ color: "primary.main" }}>
                                <Grid item xs={1}>
                                    <ListItemIcon >
                                        <LocalActivityIcon color="primary" />
                                    </ListItemIcon>
                                </Grid>
                                <Grid item xs={11}>
                                    <Typography fontSize={15} fontWeight={"bold"} mb={1} align={'left'}>
                                        Optionals :
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Paper elevation={3}>
                                <Grid container>
                                    <Grid item xs={6}>
                                        <ListItemButton onClick={handleOutingsClick} sx={{ borderTop: "3px solid #fab843", borderBottom: "3px solid #fab843" }}>
                                            <ListItemText>
                                                <Typography fontWeight={"bold"}>Outings</Typography>
                                            </ListItemText>
                                            {optional_outing_open ? <ExpandLess /> : <ExpandMore />}
                                        </ListItemButton>
                                        <Collapse in={optional_outing_open} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding sx={{ borderRight: "3px solid #fab843", }}>
                                                {Object.entries(selectedCenterValue.extras
                                                    .filter((extra) => (extra.active && extra.type == 0 && isExtraInWeekRange(extra) == true))
                                                    .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
                                                    .reduce((itemsByName, extra) => {
                                                        const name = extra.name;
                                                        if (!itemsByName[name]) {
                                                            itemsByName[name] = [];
                                                        }
                                                        itemsByName[name].push(extra);
                                                        return itemsByName;
                                                    }, {})).map(([name, items]) => (
                                                        <Grid key={name} marginLeft={4} container justifyContent={"space-between"} m={1}>
                                                            <Grid item xs={8}>
                                                                <Typography>
                                                                    {name}
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item xs={2}>
                                                                <Typography>
                                                                    {selectedCenterValue.currency == 2 ?
                                                                        <>
                                                                            {` ${getCurrencyAsString(selectedCenterValue.currency)}${items.filter((e) => e.name == name)[0].price}`}
                                                                        </>
                                                                        :
                                                                        <>
                                                                            {`${items.filter((e) => e.name == name)[0].price} ${getCurrencyAsString(selectedCenterValue.currency)}`}
                                                                        </>
                                                                    }
                                                                </Typography>
                                                            </Grid>
                                                            {
                                                                items.map((extra) => {
                                                                    const labelId = `checkbox-list-label-${extra.id}`;
                                                                    return (
                                                                        <ListItem key={extra} disablePadding>
                                                                            <ListItemButton onClick={handleExtraToggle(extra)} >

                                                                                <ListItemIcon>
                                                                                    <Checkbox
                                                                                        edge="start"
                                                                                        checked={extras.some(e => e.id == extra.id)}
                                                                                        tabIndex={-1}
                                                                                        disableRipple
                                                                                        inputProps={{ 'aria-labelledby': labelId }}
                                                                                    />
                                                                                </ListItemIcon>

                                                                                <ListItemText
                                                                                    id={labelId}
                                                                                    secondary={`${dayjs(extra.startDate).format('DD/MM/YYYY')}`} />


                                                                            </ListItemButton>
                                                                        </ListItem>
                                                                    );
                                                                })
                                                            }
                                                        </Grid>
                                                    ))}
                                            </List>
                                        </Collapse>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <ListItemButton onClick={handleProActivitiesClick} sx={{ borderTop: "3px solid #fab843", borderBottom: "3px solid #fab843" }}>
                                            <ListItemText >
                                                <Typography fontWeight={"bold"}>Pro Activities</Typography>
                                            </ListItemText>
                                            {optional_pro_activities_open ? <ExpandLess /> : <ExpandMore />}
                                        </ListItemButton>
                                        <Collapse in={optional_pro_activities_open} timeout="auto" unmountOnExit>
                                            <List component="div" disablePadding>
                                                {Object.entries(selectedCenterValue.extras
                                                    .filter((extra) => (extra.active && extra.type == 1 && isExtraInWeekRange(extra) == true))
                                                    .sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
                                                    .reduce((itemsByName, extra) => {
                                                        const name = extra.name;
                                                        if (!itemsByName[name]) {
                                                            itemsByName[name] = [];
                                                        }
                                                        itemsByName[name].push(extra);
                                                        return itemsByName;
                                                    }, {})).map(([name, items]) => (
                                                        <Grid key={name} marginLeft={4} container justifyContent={"space-between"} m={1}>
                                                            <Grid item xs={8}>
                                                                <Typography>
                                                                    {name}
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item xs={2}>
                                                                <Typography>
                                                                    {selectedCenterValue.currency == 2 ?
                                                                        <>
                                                                            {` ${getCurrencyAsString(selectedCenterValue.currency)}${items.filter((e) => e.name == name)[0].price}`}
                                                                        </>
                                                                        :
                                                                        <>
                                                                            {`${items.filter((e) => e.name == name)[0].price} ${getCurrencyAsString(selectedCenterValue.currency)}`}
                                                                        </>
                                                                    }
                                                                </Typography>
                                                            </Grid>
                                                            {items.map((extra) => {
                                                                const labelId = `checkbox-list-label-${extra.id}`;
                                                                return (
                                                                    <ListItem key={extra} disablePadding>
                                                                        <ListItemButton onClick={handleExtraToggle(extra)} >
                                                                            <ListItemIcon>
                                                                                <Checkbox
                                                                                    edge="start"
                                                                                    checked={extras.some(e => e.id == extra.id)}
                                                                                    tabIndex={-1}
                                                                                    disableRipple
                                                                                    inputProps={{ 'aria-labelledby': labelId }}
                                                                                />
                                                                            </ListItemIcon>

                                                                            <ListItemText
                                                                                id={labelId}
                                                                                secondary={`${dayjs(extra.startDate).format('DD/MM/YYYY')} → ${dayjs(extra.endDate).format('DD/MM/YYYY')}`}
                                                                            />
                                                                            <ListItemText id={labelId} />
                                                                        </ListItemButton>
                                                                    </ListItem>
                                                                );
                                                            })}
                                                        </Grid>
                                                    ))}
                                            </List>
                                        </Collapse>
                                    </Grid>
                                </Grid>
                                <List sx={{ width: '100%', bgcolor: 'background.paper' }} component="nav">


                                </List>
                            </Paper>
                        </Grid>

                    </> : <></>}
                </Grid>

            </Grid >

        </Paper >
    );
};


export default CourseDetails;

